module.exports = __webpack_public_path__ + "img/get_app-24px.da168b42.svg";